
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M245.8 9.053h-67.262c-1.023 0-1.535 1.237-.812 1.96l24.085 24.085-50.274 50.274 19.092 19.092 50.274-50.274 24.085 24.085c.723.723 1.96.211 1.96-.812V10.201c0-.634-.514-1.148-1.148-1.148zM85.41 151.498l-50.274 50.274-24.085-24.085c-.723-.723-1.96-.211-1.96.812v67.262c0 .634.514 1.148 1.148 1.148h67.262c1.023 0 1.535-1.237.812-1.96l-24.085-24.085 50.274-50.274-19.092-19.092zm159.577 26.189l-24.085 24.085-50.274-50.274-19.092 19.092 50.274 50.274-24.085 24.085c-.723.723-.211 1.96.812 1.96h67.262c.634 0 1.148-.514 1.148-1.148v-67.262c0-1.023-1.236-1.535-1.96-.812zM78.313 11.012c.723-.723.211-1.96-.812-1.96H10.24c-.634 0-1.148.514-1.148 1.148v67.262c0 1.023 1.237 1.535 1.96.812l24.085-24.085 50.274 50.274 19.092-19.092-50.275-50.274 24.085-24.085z","fill":"#FFF"}})])
          )
        }
      }
    